import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-379">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-380">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-381" />

          {/* Panel */}
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[85vh] bg-[#0d1530] border border-cyan-400/30 rounded-md shadow-2xl flex flex-col overflow-hidden" style={{
        boxShadow: '0 0 50px rgba(201, 168, 76, 0.15)'
      }} data-id="element-382">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-white/10 flex-shrink-0" data-id="element-383">
              <h2 id="modal-title" className="text-xl md:text-2xl font-serif text-white" data-id="element-384">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 rounded-full flex items-center justify-center text-cream-muted hover:text-white hover:bg-white/10 transition-colors" data-id="element-385">
                <XIcon className="w-5 h-5" data-id="element-386" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-8 py-6 text-cream-muted leading-relaxed space-y-5 text-base" data-id="element-387">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}